import { render } from "./BuyBillingView.vue?vue&type=template&id=70b2011a&scoped=true"
import script from "./BuyBillingView.vue?vue&type=script&lang=js"
export * from "./BuyBillingView.vue?vue&type=script&lang=js"

import "./BuyBillingView.vue?vue&type=style&index=0&id=70b2011a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b2011a"]])

export default __exports__